import { type RouteObject } from "react-router-dom"

import Page401 from "@pages/Error/401.page"
import Page403 from "@pages/Error/403.page"
import Page404 from "@pages/Error/404.page"

export const ErrorRouter: RouteObject[] = [
  {
    path: "/401",
    element: <Page401 />,
  },
  {
    path: "/403",
    element: <Page403 />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
]
